<template>
  <div id="Tab2">
    <div
      v-if="!disciplines || disciplines.length == 0"
      class="tab-content student-tabs-content"
    >
      <div class="d-flex align-items-center justify-content-center mt-5 py-5">
        <div class="align-items-center d-flex">
          <i class="fal big-icon mr-4 fa-folder-open text-gray-light" />
          <span class="text-gray-light message">
            No hay información de servicios disponible.
          </span>
        </div>
      </div>
    </div>
    <div v-if="disciplines" class="tab-content student-tabs-content">
      <div
        v-for="(discipline, disciplineIdx) in disciplines"
        :key="discipline.id"
      >
        <SectionTitle
          icon="fas fa-file-contract"
          :content="discipline.name"
          container-class="tag-badge-main-info mt-4 mb-4"
        />
        <div>
          <RowCard :id="'disciplines' + discipline.id">
            <RowCardItem
              v-for="(item, itemIdx) in discipline.value"
              :id="'disciplines-' + discipline.id + '-' + itemIdx"
              :key="itemIdx"
              :hide-icon="item.contracts.length == 0"
              @before-expand="
                loadContracts(disciplineIdx, itemIdx, item.requestId)
              "
            >
              <div slot="header" class="d-flex">
                <div class="d-flex align-items-start col-4 p-0">
                  <div class="icon-container">
                    <i class="far fa-check-circle text-orange" />
                  </div>
                  <div class="d-flex flex-column">
                    <span class="data-title">Status de Servicio:</span>
                    <span class="data-content">{{ item.serviceStatus }}</span>
                      <div v-if="isReturnedToSAEEByHiringLack==item.determinationReasonId" class=" bg-secondary-41  rounded pt-2 ">
                        <div class="d-flex align-items-center">
                          <em class="fa fa-bell-exclamation font-16   color-secondary-40 alert-color" />
                          <div class="font-14 font-weight-normal color-secondary-40 ml-3 alert-color">
                             Referido devuelto a la SAEE por falta de contratación
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="d-flex align-items-start col-4 p-0">
                  <div class="icon-container">
                    <i class="fas fa-address-book text-orange" />
                  </div>
                  <div class="d-flex flex-column">
                    <span class="data-title">Número de Solicitud:</span>
                    <span class="data-content">{{ item.requestNumber }}</span>
                  </div>
                </div>

                <div class="d-flex align-items-start  col-4 p-0">
                  <div class="icon-container">
                    <i class="fas fa-calendar-edit text-orange" />
                  </div>
                  <div class="d-flex flex-column">
                    <span class="data-title">Fecha de Solicitud:</span>
                    <span class="data-content">
                      {{ item.requestDate | dateFormat }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-show="canShowContract(disciplineIdx, itemIdx)"
                slot="content"
                class="contract-body p-0"
              >
                <RowCardItemCard
                  v-for="(contract, contractIdx) in item.contracts"
                  :key="contractIdx"
                  :status="contract.contractStatus"
                  :status-class="getStatusClass(contract.contractStatusId)"
                >
                  <!-- Informacion que acompañana al estado -->
                  <div slot="statusInfo">
                    <div
                      v-if="contract.contractNumber"
                      class="d-flex flex-column my-4"
                    >
                      <span class="data-title">Número de Contrato:</span>
                      <span class="data-content">
                        {{ contract.contractNumber }}
                      </span>
                    </div>
                  </div>
                  <!-- Cuerpo de la Card -->
                  <div slot="body">
                    <div class="col-12 p-0 d-flex">
                      <div class="col-3 p-0">
                        <div class="d-flex flex-column">
                          <span class="data-title">Fecha de Comienzo:</span>
                          <span
                            v-if="contract.contractFrom"
                            class="data-content"
                          >
                            {{ contract.contractFrom | dateFormat }}
                          </span>
                          <span v-else class="data-content">-</span>
                        </div>
                      </div>
                      <div class="col-3 p-0">
                        <div class="d-flex flex-column">
                          <span class="data-title">Fecha Final:</span>
                          <span v-if="contract.contractTo" class="data-content">
                            {{ contract.contractTo | dateFormat }}
                          </span>
                          <span v-else class="data-content">-</span>
                        </div>
                      </div>
                      <div class="col-6 p-0">
                        <div class="d-flex flex-row">
                          <span class="data-title">Total de Visitas:</span>
                          <span class="data-content ml-1">
                            {{ contract.totalVisit || '-' }}
                          </span>
                        </div>
                        <div class="d-flex flex-row">
                          <div class="col-6 p-0">
                            <span class="data-title">Min:</span>
                            <span
                              v-if="contract.minVisit"
                              class="data-content ml-1"
                            >
                              {{ contract.minVisit | dateFormat }}
                            </span>
                            <span v-else class="data-content ml-1">-</span>
                          </div>
                          <div class="col-6 p-0">
                            <span class="data-title">Max:</span>
                            <span
                              v-if="contract.maxVisit"
                              class="data-content ml-1"
                            >
                              {{ contract.maxVisit | dateFormat }}
                            </span>
                            <span v-else class="data-content ml-1">-</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 p-0 d-flex mt-3">
                      <div class="col-4 p-0">
                        <div class="d-flex flex-column">
                          <span class="data-title">Proveedor:</span>
                          <span class="data-content">
                            {{ contract.provider || '-' }}
                          </span>
                        </div>
                      </div>
                      <div class="col-4 p-0">
                        <div class="d-flex flex-column">
                          <span class="data-title">Especialistas:</span>
                          <div
                            v-if="
                              contract.specialists &&
                                contract.specialists.length > 0
                            "
                            class="d-flex flex-wrap"
                          >
                            <span
                              v-for="(specialist, sIdx) in contract.specialists"
                              :key="sIdx"
                              class="data-content mr-2"
                            >
                              {{ specialist }}
                            </span>
                          </div>
                          <div v-else class="d-flex flex-wrap">
                            <span class="data-content">-</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 p-0">
                        <div class="d-flex flex-column">
                          <span class="data-title">Lugar de Servicio:</span>
                          <span class="data-content">
                            {{ contract.serviceLocationName || '-' }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Extra to collapse -->
                  <div slot="extra" class="gray-squared-box">
                    <div class="white-box py-3 px-5">
                      <div class="d-flex align-items-center">
                        <i class="fas fa-info-circle text-orange mr-2" />
                        <b class="text-gray-dark">
                          Información del Contrato en Remedio Provisional
                        </b>
                      </div>
                      <div class="d-flex flex-row mt-2">
                        <div class="col-3 py-0">
                          <div class="d-flex flex-column">
                            <span class="data-title">Año Fiscal:</span>
                            <span class="data-content">
                              {{ contract.fiscalYear }}
                            </span>
                          </div>
                        </div>
                        <div class="col-3 py-0">
                          <div class="d-flex flex-column">
                            <span class="data-title">Modalidad:</span>
                            <span class="data-content">
                              {{ contract.modality }}
                            </span>
                          </div>
                        </div>
                        <div class="col-3 py-0">
                          <div class="d-flex flex-column">
                            <span class="data-title">Frecuencia:</span>
                            <span class="data-content">
                              {{ contract.frequency }}
                            </span>
                          </div>
                        </div>
                        <div class="col-3 py-0">
                          <div class="d-flex flex-column">
                            <span class="data-title">Duración:</span>
                            <span class="data-content">
                              {{ contract.duration }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Acciones -->
                  <div slot="actions">
                    <div class="dropdown text-right">
                      <button
                        class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span class="px-2">Acciones</span>
                        <i class="fa fa-angle-down" />
                      </button>
                      <div class="dropdown-menu dropdown-menu-right py-2 mt-1">
                        <div
                          class="dropdown-item"
                          @click="
                            goToServiceHistoryDocument(
                              contract.contractId,
                              false,
                              'Tab2'
                            )
                          "
                        >
                          <em class="fa fa-file-search text-green pr-1" />
                          <span>Ver Documentos</span>
                        </div>
                        <div
                          v-if="contract.totalVisit"
                          class="dropdown-item"
                          @click="
                            openVisitDetails(discipline.id, contract.visits)
                          "
                        >
                          <em class="fa fa-clock text-green pr-1" />
                          <span>Ver Visitas</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </RowCardItemCard>
              </div>
            </RowCardItem>
          </RowCard>
        </div>
      </div>
    </div>
    <VisitDetailsHistory ref="visitDetailsHistoryModal" />
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import RowCard from '@/components/common/rowcard/RowCard';
import RowCardItem from '@/components/common/rowcard/RowCardItem';
import RowCardItemCard from '@/components/common/rowcard/RowCardItemCard';
import contractStatuses from '@/utils/constants/contractStatuses.js';
import VisitDetailsHistory from '../VisitDetailsHistory';
import moment from 'moment';
import store from '@/store/index';
import DeterminationReasons from "@/utils/constants/student/determinationReason.js";
export default {
  name: 'Tab2',
  components: {
    SectionTitle,
    RowCard,
    RowCardItem,
    RowCardItemCard,
    VisitDetailsHistory,
  },
  data() {
    return {
      disciplines: null,
      showVisitDetailHistory: false,
      showingContractsIdx: null,
      showingContractsIdxs: [],
    };
  },
  props: {
    academicYearId: {
      type: Number,
      default: 0,
    },
    shouldChoseYear: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    async academicYearId() {
      await this.getReferralAdmissionHistory();
    },
  },
  filters: {
    dateFormat: function(value) {
      if (value) {
        return moment(value)
          .locale('es-PR')
          .format('DD/MMM/YYYY');
      }
    },
  },
  async mounted() {
    if (!this.shouldChoseYear) {
      await this.getReferralAdmissionHistory();
    }
  },
  computed:{
    isReturnedToSAEEByHiringLack(){
      return DeterminationReasons.ReturnedToSAEEByHiringLack
    }
  },
  methods: {
    goToStatusHistory(admissionId, referralNumber) {
      this.$router.push({
        name: 'pei-status-history',
        params: {
          admissionId: admissionId,
          referralNumber: referralNumber,
        },
      });
    },
    goToServiceHistoryDocument(contractId, allowAddDocument, tabToReturn) {
      this.$router.push({
        name: 'peiServiceHistoryDocuments',
        params: {
          contractId: contractId,
          allowAddDocument: allowAddDocument,
          tab: tabToReturn,
        },
      });
    },
    canShowContract(disciplineIdx, itemIdx) {
      return (
        this.showingContractsIdxs.indexOf(disciplineIdx + '-' + itemIdx) >= 0
      );
    },
    openVisitDetails(serviceTypeId, visits) {
      if (this.$refs.visitDetailsHistoryModal && visits) {
        this.$refs.visitDetailsHistoryModal.open(null, visits, serviceTypeId);
      }
    },
    loadContracts(disciplineIdx, itemIdx) {
      if (this.disciplines[disciplineIdx].value[itemIdx].contracts.length > 0) {
        this.showingContractsIdxs.push(disciplineIdx + '-' + itemIdx);
      }
    },
    async getReferralAdmissionHistory() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet('/api/thrpyadmission/StudentDisciplinesForRemedy/', {
            studentSieId: store.getters['$_student/StudentSie'],
            academicYearId: this.academicYearId,
          })
          .then((res) => {
            self.disciplines = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    getStatusClass(status) {
      switch (status) {
        case contractStatuses.InformaciondeContratoDenegada:
        case contractStatuses.InformaciondeContratoAprobada: {
          return 'brown';
        }
        case contractStatuses.Sometido:
        case contractStatuses.ContratoAprobado:
        case contractStatuses.ContratoFirmado:
        case contractStatuses.ContratoEnmendado: {
          return 'green';
        }
        case contractStatuses.Nuevo: {
          return 'yellow';
        }
        case contractStatuses.ContratoCancelado: {
          return 'pink';
        }
        case contractStatuses.ContratoDenegado: {
          return 'violet';
        }
        default: {
          return 'gray';
        }
      }
    },
  },
};
</script>

<style scoped>
.icon-container {
  margin-top: 3px;
  margin-right: 12px;
}
.icon-container .far,
.icon-container .fas {
  font-size: 20px;
}
.btn-dropdown-actions i.fa-angle-down {
  font-size: 12px;
  font-weight: 400;
}
.btn-dropdown-actions::after {
  border: none;
}
.dropdown-item {
  cursor: pointer;
  padding: 0.25rem 1rem;
  font-size: 15px;
}
.dropdown-item span {
  margin-left: 10px;
}
.dropdown-item em {
  min-width: 23px;
}
.message {
  font-size: 16px;
}
.big-icon {
  font-size: 3em;
}
.gray-squared-box {
  background-color: #f2f2f2;
  border-radius: 0px 0px 5px 5px;
  padding: 7px;
}
.white-box {
  border-radius: 4px;
  background-color: #ffffff;
}
.alert-color{
  color:#af6708
}
</style>
